<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <RowColumn v-if="canPurchaseProducts()" class="py-3 pl-3">
            <ButtonTag :is-w100="false" :is-tw-main-btn="true" url="products/0/purchase">
                <div class="pt-1">{{ $t('purchase') }}</div>
            </ButtonTag>
            <b-button
                class="float-right h-11 mr-3"
                variant="primary"
                @click="make"
            >
                {{ $t('product.export') }}
            </b-button>
        </RowColumn>

        <SearchCollapse class="container" :is-bg-white="true" :show-collapse="isCollapsed">
            <div class="grid grid-cols-12 gap-3"  v-if="this.isStatistic && this.$route.name === 'products-in-warehouses/page' || this.$route.name === 'products-in-warehouses'">
                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="card h-11">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('warehouse.amountSalePrice') }}
                        </div>
                        <div class="pt-3.5 pl-3">
                            {{ showCurrencyById(getWarehouseStatistic.currency.id, getWarehouseStatistic.sellingPriceTotalAmount) }}
                        </div>
                    </div>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="card h-11">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('warehouse.amountPurchasePrice') }}
                        </div>
                        <div class="pt-3.5 pl-3">
                            {{ showCurrencyById(getWarehouseStatistic.currency.id, getWarehouseStatistic.purchasePriceTotalAmount) }}
                        </div>
                    </div>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="card h-11">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('warehouse.TotalAmountProducts') }}
                        </div>
                        <div class="pt-3.5 pl-3">
                            {{ getWarehouseStatistic.productsTotalCount }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-12 gap-3 mt-4">
                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('product.barcode') }}
                    </div>
                    <b-form-input
                        v-model="search.barCode"
                        class="focus:ring-0 border-gray-300 h-11"
                        @input="searchProductByBarCode"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('product.name') }}
                    </div>
                    <b-form-input
                        v-model="search.productName"
                        class="focus:ring-0 border-gray-300 h-11"
                        @keyup.enter="searchProductInWarehouses"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('warehouse.name') }}
                    </div>
                    <b-form-input
                        v-model="search.warehouseName"
                        class="focus:ring-0 border-gray-300 h-11"
                        @keyup.enter="searchProductInWarehouses"
                    >
                    </b-form-input>
                </div>
            </div>

            <div class="grid grid-cols-12 gap-3 mt-4">
                <div class="col-span-12 md:col-span-3 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('filter.fromAmount') }}
                    </div>
                    <b-form-input
                        v-model="search.minAmount"
                        class="focus:ring-0 border-gray-300 h-11"
                        type="number"
                        @keyup.enter="searchProductInWarehouses"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-3 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('filter.toAmount') }}
                    </div>
                    <b-form-input
                        v-model="search.maxAmount"
                        class="focus:ring-0 border-gray-300 h-11"
                        type="number"
                        @keyup.enter="searchProductInWarehouses"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-3 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('category') }}
                    </div>
                    <TreeCheckBox
                        model-name="category"
                        :model-form="search"
                        :options="this.getProductCategoriesTree"
                        :multiple="false"
                        :no-margin-top="true"
                        class="d-flex p-0 h-11"
                    />
                </div>

                <div class="col-span-12 md:col-span-3 position-relative">
                    <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-11 w-50 focus:outline-none">
                        <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchProductInWarehouses">
                    </button>
                    <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-11 w-50 focus:outline-none">
                        <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetProductInWarehousesInfo">
                    </button>
                </div>
            </div>
        </SearchCollapse>

        <table class="w-full mt-3">
            <thead class="h-11 bg-lightGray">
            <tr>
                <th class="d-none d-md-table-cell px-2">#</th>
                <th class="px-2">{{ $t('product.title') }}</th>
                <th class="d-none d-md-table-cell px-2">{{ $t('warehouse.title') }}</th>
                <th class="d-none d-md-table-cell px-2">{{ $t('category') }}</th>
                <th class="px-2">{{ $t('amount') }}</th>
                <th class="d-none d-sm-table-cell px-2">Summa</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in inWarehouses" v-bind:key="item.id" class="h-11 border-bottom">
                <td class="d-none d-md-table-cell px-2">{{ item.id }}</td>
                <td class="font-bold text-main">
                    <img :src="item.product.image ? url + item.product.image.contentUrl : ''" height="23px"
                         alt=""
                         @click="setModal(item.product.name, url + item.product.image.contentUrl)"
                    >
                    {{ item.product.name }}
                </td>
                <td class="d-none d-md-table-cell">{{ item.warehouse.name }}</td>
                <td class="d-none d-md-table-cell">{{ findCategoryName(index) }}</td>
                <td class="px-2 w-48">
                    <div class="border rounded border-gray-300 p-1 h-8">
                        <span v-for="(unit, index) of item.unitOfMeasures" :key="index">
                            <span class="pl-2" v-if="unit.remainder > 0">
                                {{ unit.remainder }} {{ showUnitOfMeasure(unit.unitOfMeasure) }}
                            </span>
                        </span>
                        <span
                            class="text-primary float-right pointer-event pr-2"
                            @click="findProductsParty(item)"
                        >
                            <img src="/images/down-arrow-blue.png" alt="" class="h-4">
                        </span>
                        <span v-if="indexPurchase === item.id">
                            <span
                                v-for="(purchase, index) of productResidues"
                                :key="index"
                                class="d-block mx-2"
                                style="border-top: #6f42c1 solid 1px"
                            >
                                {{ dateFormat(purchase.createdAt) }}&nbsp; &nbsp;
                                <span v-for="addMeasure of purchase.unitOfMeasures" :key="addMeasure.index">
                                    <span v-if="addMeasure.remainder > 0">{{
                                            addMeasure.remainder
                                        }} {{ showUnitOfMeasure(addMeasure.unitOfMeasure) }}&nbsp; &nbsp;</span>
                                </span>
                            </span>
                        </span>
                    </div>
                </td>
                <td class="d-none d-sm-table-cell pl-2">
                    {{
                        showCurrencyById(item.product.sellingPriceCurrency.id, item.product.sellingPrice * item.amount)
                    }}
                </td>
            </tr>
            </tbody>
        </table>
        <div v-if="getProductsInWarehouses.length === 0" class="col-12">{{ $t('noData') }}</div>


        <div class="row">
            <div class="col mt-3 ml-3">
                <Pagination
                    :search="search"
                    base-url="products-in-warehouses"
                    :total-items="getProductsInWarehousesTotalCount"
                    method-name="searchProductInWarehouse"
                />
            </div>
        </div>
        <ModalWithPicture id="show_picture" :img="itemImageUrl" :title="itemName"/>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Pagination from "../../components/html/Pagination";
import ModalWithPicture from "../../components/html/ModalWithPicture";
import RowColumn from "@/components/RowColumn";
import ButtonTag from "@/components/html/ButtonTag";
import accessMixin from "@/mixin/accessMixin";
import SearchCollapse from "@/components/SearchCollapse";
import TreeCheckBox from "@/components/TreeCheckBox";
import currencyFormat from "@/mixin/currencyFormatMixin";
import Row from "@/components/html/Row";
import dateFormatting from "@/mixin/dateFormattingMixin";
import {exportFile} from "@/store/local/exportFile";

export default {
    name: "ProductsInWarehouse",
    components: {
        Row,
        ButtonTag,
        RowColumn,
        ModalWithPicture,
        Pagination,
        SearchCollapse,
        TreeCheckBox
    },
    mixins: [accessMixin, currencyFormat, dateFormatting,],
    data() {
        return {
            inWarehouses: [],
            productResidues: [],
            indexPurchase: -1,
            isStatistic: false,
            totalAmount: 0,
            unites: [],
            productIndex: null,
            isCollapsed: false,
            itemName: '',
            itemImageUrl: '',
            url: process.env.VUE_APP_API_URL,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'product.title'},
            ],
            search: {
                barCode: null,
                productName: '',
                warehouseName: '',
                warehouseId: '',
                minAmount: '',
                maxAmount: '',
                category: null,
                page: 1
            },
            fileExportProduct: []
        }
    },
    computed: {
        ...mapGetters([
            'getSale',
            'getProductsInWarehouses',
            'getAllProductsInWarehouses',
            'getProductsInWarehousesTotalCount',
            'getProductCategory',
            'getProductCategoriesTree',
            'getWarehouseStatistic',
            'getProductResidues',
        ]),
    },
    methods: {
        ...mapActions([
            'searchProductInWarehouse',
            'fetchAllProducts',
            'fetchProductCategory',
            "fetchProductCategoriesTree",
            'fetchWarehouseStatistics',
            'pushProductInWarehouseProductResidue',
            'setBreadcrumbItems'
        ]),
        definitionProductInWarehouses(productsInWarehouses) {
            this.inWarehouses = []

            for (let productsInWarehouse of productsInWarehouses) {
                this.unitOfMeasuresCount(productsInWarehouse, productsInWarehouse.index)

                productsInWarehouse.unitOfMeasures = this.unites
                this.inWarehouses.push(productsInWarehouse)
            }
        },
        definitionProductResidues(productPurchases) {
            this.productResidues = []

            for (let productPurchase of productPurchases) {
                this.unitOfMeasuresCount(productPurchase, productPurchase.index)

                productPurchase.unitOfMeasures = this.unites
                this.productResidues.push(productPurchase)
            }
        },
        calculateRemainder(additionalUnitOfMeasure) {
            if (this.totalAmount === additionalUnitOfMeasure.howMany) {
                return additionalUnitOfMeasure.howMany
            }

            if (this.totalAmount / additionalUnitOfMeasure.howMany > 1) {
                let unit = Math.floor(this.totalAmount / additionalUnitOfMeasure.howMany)
                this.totalAmount = this.totalAmount % additionalUnitOfMeasure.howMany

                return unit
            } else {
                return 0
            }

        },
        unitOfMeasuresCount(item, index) {
            if (index === this.productIndex) {
                this.unites = []
                this.productIndex = 1000000
            } else {
                this.productIndex = index
            }

            this.unites = []
            let addUnitOfMeasures = []

            item.product.additionalUnitOfMeasures.forEach(unit => {
                addUnitOfMeasures.push(unit)
            })

            addUnitOfMeasures = addUnitOfMeasures.sort((a, b) => b.howMany - a.howMany)
            addUnitOfMeasures.push({unitOfMeasure: item.product.unitOfMeasure, howMany: 1})
            this.totalAmount = item.amount

            for (let additionalUnitOfMeasure of addUnitOfMeasures) {
                this.unites.push({
                    unitOfMeasure: additionalUnitOfMeasure.unitOfMeasure,
                    remainder: this.calculateRemainder(additionalUnitOfMeasure)
                })
            }
        },
        findProductsParty(product) {
            if (this.indexPurchase === product.id) {
                this.indexPurchase = null
            } else {
                this.$root.showOverlay = true

                this.pushProductInWarehouseProductResidue({
                    warehouse: product.warehouse['@id'],
                    product: product.product['@id']
                })
                    .then(() => {
                        this.indexPurchase = product.id
                        this.$root.showOverlay = false
                    })
            }
        },
        setModal(name, url) {
            this.itemName = name
            this.itemImageUrl = url
            this.$bvModal.show('show_picture')
        },
        isNumber(n) {
            return /^-?[\d.]+(?:e-?\d+)?$/.test(n)
        },
        searchProductByBarCode() {
            if (this.isNumber(this.search.barCode) && this.search.barCode.length === 13) {
                this.searchProductInWarehouses()
            }
        },
        searchProductInWarehouses() {
            this.$root.showOverlay = true

            if (this.$route.name === 'products-in-warehouse') {
                this.$i18nHelper.toUrl('products-in-warehouses')
            } else {
                this.searchProductInWarehouse(this.search)
                    .catch((err) => {
                        console.log(err)
                    })
                    .finally(() => {
                        this.$root.showOverlay = false
                    });
            }
        },
        resetProductInWarehousesInfo() {
            Object.assign(this.$data, this.$options.data.call(this));

            if (this.$route.name === 'products-in-warehouse') {
                this.$i18nHelper.toUrl('products-in-warehouses')
            } else {
                this.searchProductInWarehouses()
            }
        },
        findCategoryName(index) {
            let categoryName = ''
            let objectWarehouse = this.getProductsInWarehouses[index]

            if (objectWarehouse.product.categories.length === 0) {
                return categoryName
            }

            for (let i = 0; i < objectWarehouse.product.categories.length; i++) {
                categoryName = categoryName + objectWarehouse.product.categories[i].name + ' '
            }

            return categoryName
        },
        exportData() {
            exportFile().exportDataFromJSON(this.fileExportProduct, this.fileName, 'xls')
            this.$root.showOverlay = false

        },
        makeProductExport() {
            console.log(this.getAllProductsInWarehouses)

            for (let piw of this.getAllProductsInWarehouses) {
                let row = {}
                row[this.$t('product.title')] = piw.product.name
                row[this.$t('amount')] = parseFloat(piw.amount)
                row[this.$t('sellingPrice')] = parseFloat(piw.product.sellingPrice)
                row[this.$t('unitOfMeasure.unitOfMeasure')] = piw.product.unitOfMeasure
                row[this.$t('warehouse.title')] = piw.warehouse.name
                row[this.$t('category')] = piw.product.categories.length > 0 ? piw.product.categories[0].name : "-"
                row[this.$t('supplier.title')] = piw.productPurchase.supplier.supplierCompany ? piw.productPurchase.supplier.supplierCompany.name : piw.productPurchase.supplier.person.givenName + ' ' + piw.productPurchase.supplier.person.familyName

                this.fileExportProduct.push(row)
            }
        },
        async make() {
            this.$root.showOverlay = true

            await this.makeProductExport()
            await this.exportData()
            this.fileExportProduct = []
        },
    },
    watch: {
        'getProductsInWarehouses'() {
            this.definitionProductInWarehouses(this.getProductsInWarehouses)
        },
        'getProductResidues'() {
            this.definitionProductResidues(this.getProductResidues)
        },
        '$route.name'() {
            if (this.$route.name === 'products-in-warehouses') {
                this.fetchWarehouseStatistics()
                    .then(() => {
                        this.isStatistic = true
                    })
            }
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    beforeMount() {
        if (this.$route.name === 'products-in-warehouse') {
            this.search.warehouseId = this.$route.params.id
        }
    },
    mounted() {
        if (this.$route.name === 'products-in-warehouses') {
            this.fetchWarehouseStatistics()
                .then(() => {
                    this.isStatistic = true
                })
        }

        this.fetchAllProducts()
        this.fetchProductCategoriesTree(this.search.page)
    },
}
</script>

<style scoped>
.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}

img {
    cursor: pointer;
}
</style>
